import React from 'react';
import DOMPurify from 'dompurify';

// 安全的 HTML 渲染器，不使用 iframe
const SafeHTMLRenderer = ({ htmlContent, title = "HTML Content" }) => {
  // 清理 HTML 內容，移除所有腳本和危險元素
  const cleanHTML = DOMPurify.sanitize(htmlContent, {
    ALLOWED_TAGS: [
      'div', 'span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'br', 
      'strong', 'em', 'u', 'i', 'b', 'a', 'img', 'button', 'input', 
      'form', 'table', 'tr', 'td', 'th', 'ul', 'ol', 'li', 'canvas', 
      'svg', 'style', 'figure', 'figcaption', 'section', 'article', 
      'header', 'footer', 'nav', 'aside', 'main'
    ],
    ALLOWED_ATTR: [
      'class', 'id', 'style', 'src', 'href', 'target', 'width', 'height', 
      'alt', 'title', 'type', 'value', 'placeholder', 'disabled', 'readonly', 
      'checked', 'selected', 'data-src', 'data-alt', 'loading', 'decoding', 
      'sizes', 'srcset', 'usemap', 'ismap', 'crossorigin', 'referrerpolicy', 
      'fetchpriority', 'role', 'aria-label', 'aria-labelledby'
    ],
    ALLOW_DATA_ATTR: true,
    ALLOW_UNKNOWN_PROTOCOLS: true,
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|data|blob):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    // 移除所有事件處理器
    FORBID_ATTR: ['onclick', 'onload', 'onerror', 'onmouseover', 'onmouseout', 'onfocus', 'onblur']
  });

  return (
    <div className="safe-html-container">
      <div 
        className="safe-html-content"
        dangerouslySetInnerHTML={{ __html: cleanHTML }}
        style={{
          padding: '16px',
          backgroundColor: '#212121',
          color: '#ececf1',
          borderRadius: '8px',
          border: '1px solid #565869',
          maxWidth: '100%',
          overflow: 'auto'
        }}
      />
    </div>
  );
};

export default SafeHTMLRenderer;

